/**
 * Ziffernblock der Kasse (K6): Der gegebene Betrag liegt immer als **ganze Cent** vor, nie als Gleitkommazahl und nie als
 * Text, den man erst wandeln müsste. Jede Ziffer schiebt die Cent-Zahl nach links (wie am Taschenrechner einer Kasse:
 * 2, 0, 0, 0 ergibt 20,00 €), Scheine addieren. Was die Obergrenze überschritte, wird nicht angenommen (Eingabe bleibt).
 */

/** Höchster Betrag, der eingegeben werden kann (5.000 €, wie der höchste Preis eines Artikels). */
export const MAX_GIVEN_CENTS = 500_000;

/** Scheine zum Zusammenzählen (Cent). */
export const NOTE_CENTS = [500, 1000, 2000, 5000] as const;

/** Schiebt Ziffern hinten an („00“ schiebt zwei Nullen). Ungültige Zeichen oder Überschreitung: unverändert. */
export function pushDigits(cents: number, digits: string): number {
  if (!/^\d{1,2}$/.test(digits)) return cents;
  const next = cents * 10 ** digits.length + Number(digits);
  return next > MAX_GIVEN_CENTS ? cents : next;
}

/** Löscht die letzte Ziffer. */
export function removeLastDigit(cents: number): number {
  return Math.floor(cents / 10);
}

/** Addiert einen Schein; über der Obergrenze unverändert. */
export function addNote(cents: number, noteCents: number): number {
  if (!Number.isInteger(noteCents) || noteCents <= 0) return cents;
  const next = cents + noteCents;
  return next > MAX_GIVEN_CENTS ? cents : next;
}

/** Ziffernfolge für den Code (Handeingabe): nur Ziffern, höchstens `max` Stellen. */
export function pushCodeDigits(text: string, digits: string, max = 16): string {
  if (!/^\d{1,2}$/.test(digits)) return text;
  const next = text + digits;
  return next.length > max ? text : next;
}

/** Löscht die letzte Stelle des Codes. */
export function removeLastCodeDigit(text: string): string {
  return text.slice(0, -1);
}
